import { Component, inject } from '@angular/core';
import { CookiePolicyService } from '../../services/cookie-policy.service';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-cookie-popup',
    templateUrl: './cookie-popup.component.html',
    styleUrls: ['./cookie-popup.component.scss'],
    imports: [NgClass, RouterLink]
})
export class CookiePopupComponent {
  cookiePolicyService = inject(CookiePolicyService);


  accept(): void {
    this.cookiePolicyService.accept();
  }
}
